"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unchecked = exports.Checked = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Checked = function Checked(props) {
  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: 2,
      fill: "none",
      fillRule: "evenodd",
      children: (0, _jsxRuntime.jsx)("g", {
        id: "Radio-Button-/-Selected",
        transform: "translate(-32.000000, -32.000000)",
        children: (0, _jsxRuntime.jsxs)("g", {
          transform: "translate(-32.000000, -32.000000)",
          id: "Oval",
          children: [(0, _jsxRuntime.jsx)("circle", {
            stroke: theme.colors.primary.medium,
            cx: 16,
            cy: 16,
            r: 15
          }), (0, _jsxRuntime.jsx)("circle", {
            fill: theme.colors.primary.medium,
            cx: 16,
            cy: 16,
            r: 10
          })]
        })
      })
    })
  }));
}; // eslint-disable-next-line react/prop-types


exports.Checked = Checked;

var Unchecked = function Unchecked(_ref) {
  var disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["disabled"]);

  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: 2,
      fill: "none",
      fillRule: "evenodd",
      children: (0, _jsxRuntime.jsx)("g", {
        id: "Radio-Button-/-Unselected",
        transform: "translate(-32.000000, -32.000000)",
        stroke: disabled ? theme.colors.neutral[200] : theme.colors.neutral[400],
        children: (0, _jsxRuntime.jsx)("g", {
          transform: "translate(-32.000000, -32.000000)",
          id: "Oval-Copy-2",
          children: (0, _jsxRuntime.jsx)("circle", {
            cx: 16,
            cy: 16,
            r: 15
          })
        })
      })
    })
  }));
};

exports.Unchecked = Unchecked;